import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmptyStateContainer } from './styled';

const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <EmptyStateContainer>
      <Typography variant="h4">
        {t('library:studioSongs:emptyState')}
      </Typography>
    </EmptyStateContainer>
  );
};

export default EmptyState;
